module.exports = "/assets/data/27b491ec7d7d6195cf1c5571b193461d-KW14.data.json";